// The preset clauses offered by the Amendment to PSA popup.
//
// One clause per amendment: the picker is single-select, and two changes mean
// two amendments. VALUE is the key the form holds, LABEL is what the picker
// shows, and `input` is the extra field the clause needs before it can be
// written:
//
//   date      a calendar date the clause extends to
//   days      a number of days, which also resolves to a date
//   currency  an amount
//   text      the agent's own wording, inserted verbatim
//
// The wording itself lives with the builder in PsaAmendmentForm, so the clause
// text and the formatting helpers it needs stay in one place.
export default [
    {
        VALUE: 'FEASIBILITY_UNTIL',
        LABEL: 'Feasibility Period — extended until a date',
        input: 'date',
    }, {
        VALUE: 'FEASIBILITY_DAYS',
        LABEL: 'Feasibility Period — extended by days',
        input: 'days',
        default: '7',
    }, {
        VALUE: 'CLOSING_UNTIL',
        LABEL: 'Closing Date — extended until a date',
        input: 'date',
    }, {
        VALUE: 'CLOSING_DAYS',
        LABEL: 'Closing Date — extended by days',
        input: 'days',
        default: '7',
    }, {
        VALUE: 'PRICE_REDUCED',
        LABEL: 'Purchase Price — reduced',
        input: 'currency',
    }, {
        VALUE: 'WAIVE_FEASIBILITY_CREDIT',
        LABEL: 'Feasibility waived, with a credit to Buyer at Closing',
        input: 'currency',
    }, {
        VALUE: 'FREE_TEXT',
        LABEL: 'Other — type the clause',
        input: 'text',
    },
]
